import Vue from "vue";
import Vuex from "vuex";

import solution from "./solution/index";
import employeeAccess from "./employeeAccess/index";
import user from "./user/index";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    solution,
    employeeAccess,
    user
  },

  state: {},
  mutations: {},
  actions: {}
});
